import { createTypedSxStyles, capitalDesignTokens } from '@opengov/capital-mui-theme';

const muiV37Red500 = '#F35C49';

export const styles = createTypedSxStyles({
  statusCell: {
    width: '20%'
  },
  spinnerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  spinner: {
    marginRight: '16px'
  },
  errorChip: {
    padding: '0px 4px',
    backgroundColor: muiV37Red500,
    fontFamily: capitalDesignTokens.foundations.typography.baseFont,
    '& .MuiChip-icon': {
      marginRight: '2px'
    }
  }
});
